import { Component, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  UntypedFormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApilistService } from '../services/apilist.service';
import { CommonService } from '../services/common.service';
import { GlobalService } from '../services/global.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-advertisement-video',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './advertisement-video.component.html',
  styleUrls: ['./advertisement-video.component.scss'],
})
export class AdvertisementVideoComponent implements OnInit {
  display: any = 'none';
  displayDelete: any = 'none';
  showAdd = false;
  showEdit = false;
  imgTypeId: any;

  fileToUpload: any;
  imageUrl: any;
  imgType: any;
  imgData: any;
  id: any;
  urls: any;
  showErr = false;
  deleteErr: any;
  countryid: any;
  countryVal: any;
  trendingCourse: any;
  foreignCourse: any;
  adminName: any;
  adminImage: any;
  allCountry: any;
  allData: any;

  imageForm: UntypedFormGroup;

  showNodashboard = false;
  showDashboard = false;

  showTrending = false;
  showNotrending = false;

  showForegin = false;
  showNoForeign = false;

  searchval: any;

  imageTrueFalse: boolean = false;
  payload: any;
  images = [];
  videourl: any;
  error_messages = {
    imageVal: [{ type: 'required', message: 'Please select image' }],
    countryName: [{ type: 'required', message: 'Please select country' }],
    imageTypeVal: [{ type: 'required', message: 'Please select image type' }],
  };
  materialdata: any;
  showMaterial: boolean;
  showNoMaterial: boolean;
  videos: any;
  showData = false;
  showNodata = false;
  allVideos: any;
  advertisementurl: any;

  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService
  ) {
    this.imageForm = this.formBuilder.group({
      imageVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      countryName: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      imageTypeVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      url: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    // this.imageUrl = 'assets/tenant-avatar.jpg';

    let admin = JSON.parse(localStorage.getItem('adminDetails'));
    let adminData = JSON.parse(admin);

    this.adminName = adminData[0].name;
    this.adminImage = adminData[0].image;
    if (this.adminImage == null || this.adminImage == undefined) {
      this.adminImage = 'assets/tenant-avatar.jpg';
    }
  }

  ngOnInit(): void {
    this.getallmaterialimage();
    this.getvideourl();

    // Dashboard Type \\
    const servicePathType = this.utils.getApiConfigs('dashboardtype');
    // console.log("servicePathCollege", servicePathType);
    this.commonservice
      .invokeService(servicePathType[0].method, servicePathType[0].path, '')
      .then((resp: any) => {
        if (resp.status_code == '200') {
          this.imgType = resp.data;
          // console.log("Img type", this.imgType);
        }
      });

    // GET COUNTRY \\
    const servicePathCountry = this.utils.getApiConfigs('country');
    // console.log("servicePathCollege", servicePathCountry);
    this.commonservice
      .invokeService(
        servicePathCountry[1].method,
        servicePathCountry[1].path,
        ''
      )
      .then((resp: any) => {
        if (resp.status_code == '200') {
          this.countryVal = resp.data;
          // console.log("Country", this.countryVal);
        }
        this.allCountry = this.countryVal;
      });

    // Dashboard Image \\
    this.spinner.show();
    const servicePathCollege = this.utils.getApiConfigs('dashboard');
    // console.log("servicePathCollege", servicePathCollege);
    this.commonservice
      .invokeService(
        servicePathCollege[1].method,
        servicePathCollege[1].path,
        ''
      )
      .then((resp: any) => {
        // console.log("resp Dashboard", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.imgData = resp.data;
          // console.log("Dashboard", this.imgData);
          if (this.imgData == '') {
            this.showDashboard = false;
            this.showNodashboard = true;
          } else {
            this.showDashboard = true;
            this.showNodashboard = false;
          }
        }
      });

    // Trending courses \\
    this.spinner.show();
    const servicePathTrending = this.utils.getApiConfigs('alltrendingcourse');
    this.commonservice
      .invokeService(
        servicePathTrending[0].method,
        servicePathTrending[0].path,
        ''
      )
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.trendingCourse = resp.data;
          // console.log("Trending course", this.trendingCourse);

          if (this.trendingCourse == '') {
            this.showTrending = false;
            this.showNotrending = true;
          } else {
            this.showTrending = true;
            this.showNotrending = false;
          }
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          if (resp.messages == 'No Records found') {
            this.showTrending = false;
            this.showNotrending = true;
          } else {
            this.showTrending = true;
            this.showNotrending = false;
          }
        }
      });

    // Foreign University \\
    this.spinner.show();
    const servicePathForeign = this.utils.getApiConfigs('allforeignuniversity');
    this.commonservice
      .invokeService(
        servicePathForeign[0].method,
        servicePathForeign[0].path,
        ''
      )
      .then((resp: any) => {
        // console.log("resp fore", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.foreignCourse = resp.data;
          // console.log("Forregin", this.foreignCourse);

          if (this.foreignCourse == '') {
            this.showForegin = false;
            this.showNoForeign = true;
          } else {
            this.showForegin = true;
            this.showNoForeign = false;
          }
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          if (resp.messages == 'No Records found') {
            this.showForegin = false;
            this.showNoForeign = true;
          } else {
            this.showForegin = true;
            this.showNoForeign = false;
          }
        }
      });
  }

  getallmaterialimage() {
    this.spinner.show();
    const servicePathTrending = this.utils.getApiConfigs('dashboardneet');
    this.commonservice
      .invokeService(
        servicePathTrending[0].method,
        servicePathTrending[0].path,
        ''
      )
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.materialdata = resp.data;
          // console.log("Trending course", this.trendingCourse);

          if (this.materialdata == '') {
            this.showMaterial = false;
            this.showNoMaterial = true;
          } else {
            this.showMaterial = true;
            this.showNoMaterial = false;
          }
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          if (resp.messages == 'No Records found') {
            this.showMaterial = false;
            this.showNoMaterial = true;
          } else {
            this.showMaterial = true;
            this.showNoMaterial = false;
          }
        }
      });
  }
  ////////////////\

  openAdd() {
    this.display = 'block';
    this.imageForm.reset();
    this.images = [];
    this.imageUrl = '';
    this.showAdd = true;
    this.showEdit = false;
  }

  handleFileInput(event) {
    // console.log("event", event.target.files);

    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;

      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.images.push(event.target.result);
          this.imageTrueFalse = true;
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  onChangeEvent(event) {
    // console.log("event", event);

    var val = event.target.value;
    // console.log("val", val);

    this.allData = this.countryVal;

    // console.log("All Data", this.allData);

    if (val) {
      this.allCountry = this.allData.filter((item) =>
        item.country.toLowerCase().includes(val.toLowerCase())
      );
    }

    // console.log("Courses Data", this.allCountry);
    if (this.allCountry == '') {
      this.globalService.showError('No data found');
    }
  }

  reset() {
    this.ngOnInit();
    this.searchval = '';
  }

  editImage(data) {
    // console.log("Data", data);
    this.display = 'block';
    this.showAdd = false;
    this.showEdit = true;

    this.imgTypeId = data.type_id;
    this.imageUrl = data.image;
    this.id = data.id;
    this.countryid = data.country_id;
  }

  deleteImage(data) {
    this.displayDelete = 'block';
    this.deleteErr = '';
    this.id = data.id;
  }

  onCloseHandled() {
    this.display = 'none';
    this.displayDelete = 'none';
  }
  videourldata(event) {
    console.log('videourl', event);
    console.log('advertisementurl', this.advertisementurl);
  }

  addvideos() {
    this.spinner.show();
    let payload = {
      type_id: this.imgTypeId,
      image: this.images,
      url: this.advertisementurl,
    };
    console.log('videourl', this.advertisementurl);
    console.log('payload', payload);
    const servicePath = this.utils.getApiConfigs('dashboardurl');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        console.log('resp', resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          // console.log(resp);
          this.spinner.hide();
          this.globalService.showSuccess('Image Added Successfully');
          this.display = 'none';
          this.ngOnInit();
          this.imageForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.data);
        }
      });
  }

  imgUpdate() {
    this.spinner.show();
    if (this.imageTrueFalse == true) {
      this.payload = {
        id: this.id,
        type_id: this.imgTypeId,
        user_image: this.images,
        country_id: this.countryid,
      };
    } else {
      this.payload = {
        id: this.id,
        type_id: this.imgTypeId,
        country_id: this.countryid,
      };
    }

    // console.log("payload", this.payload);
    const servicePath = this.utils.getApiConfigs('dashboard');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, this.payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          // console.log(resp);
          this.spinner.hide();
          this.globalService.showSuccess('Image Updated Successfully');
          this.display = 'none';
          this.ngOnInit();
          this.imageForm.reset();
          this.imageTrueFalse = false;
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.data);
        }
      });
  }

  getvideourl() {
    this.spinner.show();
    const servicePathVideo = this.utils.getApiConfigs('dashboardvideo');
    //  console.log("servicePathCollege",servicePathVideo);
    this.commonservice
      .invokeService(servicePathVideo[0].method, servicePathVideo[0].path, '')
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.videos = resp.data;
          console.log('Videos', this.videos);

          if (this.videos == '') {
            this.showNodata = true;
            this.showData = false;
          } else {
            this.showData = true;
            this.showNodata = false;
          }
        }

        this.allVideos = this.videos;
      });
  }
  deleteVideo(id) {
    // console.log("data", data);
    this.displayDelete = 'block';
    this.deleteErr = '';
    this.id = id;
  }

  delete() {
    this.spinner.show();
    let payload = {
      id: this.id,
    };
    console.log('payload', payload);
    const servicePath = this.utils.getApiConfigs('removedashboardurl');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          console.log('deleteresponse', resp);
          this.globalService.showSuccess('Image deleted successfully');
          this.displayDelete = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.data);
          this.showErr = true;
          this.deleteErr = resp.message;
        }
      });
  }
}
